<script>
import axios from 'axios';
import trans from '../mixins/trans';

export default {

    mixins: [
        trans
    ],

    props: [
        'trainings'
    ],

    methods: {
        addToCart() {
            axios.post('/warenkorb', {
                'trainings': this.trainings
            })
                .then((response) => {
                    window.app.$refs.miniCart.update();
                    window.app.$refs.miniCart.$refs.cart.update()
                    window.app.$refs.cartFlyout.show();
                })
        }
    }
}
</script>